var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74967 6.41602V9.91602L5.91634 8.74935M4.74967 9.91602L3.58301 8.74935",
    stroke: "#505054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3337 5.83268V8.74935C12.3337 11.666 11.167 12.8327 8.25033 12.8327H4.75033C1.83366 12.8327 0.666992 11.666 0.666992 8.74935V5.24935C0.666992 2.33268 1.83366 1.16602 4.75033 1.16602H7.66699",
    stroke: "#505054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3337 5.83268H10.0003C8.25033 5.83268 7.66699 5.24935 7.66699 3.49935V1.16602L12.3337 5.83268Z",
    stroke: "#505054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelDownload);
export default __webpack_public_path__ + "static/media/excelDownload.2a4b88009da07dc2d4046486b1a8bcd4.svg";
export { ForwardRef as ReactComponent };